import React, { useState, useEffect } from "react";

import { injectIntl, FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import numeral from "numeral";

import WidgetCard from "./card";
import { usePermissions } from "../../customHooks";

const WidgetCreditsAndRevenues = props => {
  const { analytics, accountantIdSelected, currentPermissions, user, usersList } = props;
  const [isOwner, setIsOwner] = useState(false);
  const { isPermissionCredits, isPermissionRevenues } = usePermissions(
    currentPermissions, null, isOwner
  );

  useEffect(() => {
    const roles = user.roles;
    const isOwnerResources = roles.filter(resource => resource.actionKey === "OWNER" && (resource.appId === "DBX" || resource.appId === null));
    const currentStudio = isOwnerResources.filter(res => res.resourceId === accountantIdSelected);
    if (currentStudio.length > 0) {
      setIsOwner(true);
    }
  }, [user, usersList]);

  const permissionUser = currentPermissions.permissionUser;

  if (analytics) {
    const credits =
      analytics.getCredits &&
      analytics.getCredits.data &&
      analytics.getCredits.data.values;
    const revenues =
      analytics.getRevenues &&
      analytics.getRevenues.data &&
      analytics.getRevenues.data.values;

    // CREDITI
    let countInvoices;
    let countProforma;
    let totalProforma;
    let totalInvoices;
    let totalCredit;

    // RICAVI
    let positive;
    let yearRevenues;
    let percentage;
    let totalRevenues;
    let totalOldYear;

    if (credits && credits.data && credits.data.length > 0) {
      totalProforma = numeral(Math.abs(credits.data[0].ImportoTotaleNotule)).format("0,0.00");
      totalInvoices = numeral(Math.abs(credits.data[0].ImportoDaPagareFatture)).format("0,0.00");
      countInvoices = credits.data[0].NumeroFattureDaPagare;
      countProforma = credits.data[0].NumeroNotuleDaPagare;
      totalCredit = numeral(Math.abs(credits.data[0].ImportoDaPagareFatture +
          credits.data[0].ImportoTotaleNotule)).format("0,0.00");
    }

    if (revenues && revenues.data && revenues.data.length > 0) {
      positive =
        Number(revenues.data[0].PercentualeIncrementoRicavi) > 0 ? true : false;
      yearRevenues = revenues.dataElaborazione
        ? moment(revenues.dataElaborazione, "YYYYMMDDHHmmss").year() - 1
        : new Date().getFullYear() - 1;

      percentage = Math.abs(Number(revenues.data[0].PercentualeIncrementoRicavi));
      totalRevenues = numeral(Math.abs(revenues.data[0].RicaviAnnoInCorso)).format("0,0.00");
      totalOldYear = numeral(revenues.data[0].RicaviAnnoPrecedente).format("0,0.00");
    }

    const manageStudioLanding = "https://digital.teamsystem.com/lp-digital-box-gestione-studio";

    const renderEmptyWidget = type => {
      return (
        <div className="emptyWidgetContainer">
          <div className={"titleWidgetCreditsAndRevenues empty"}>
            <FormattedMessage id={"creditsAndRevenues." + type} />{" "}
          </div>
          <div className="emptyContent">
            <div className={"placeholder"} onClick={() => {
              if (window.aptrinsic) {
                type === "credits" ? window.aptrinsic("track", "digital-box:SC-CREDITI") : window.aptrinsic("track", "digital-box:SC-RICAVI");
              }

            }}>
              <FormattedMessage id={"creditsAndRevenues.placeholder" + type} />{" "}
              <a target="_blank" rel="noopener noreferrer" href={manageStudioLanding}>Scopri di più</a>.
            </div>
            <div style={{ marginRight: "5px" }}>
              <FontAwesomeIcon
                icon={["far", "cloud-upload"]}
                className="cloudStyle"
              />
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className={"cardSkeleton noBoxShadow"}>
        {currentPermissions && permissionUser && isPermissionCredits ?
          (<WidgetCard type="CreditsAndRevenues">
            {credits && Object.keys(credits).length > 0 ? (
              <React.Fragment>
                <div className={"titleWidgetCreditsAndRevenues"}>
                  <FormattedMessage id="creditsAndRevenues.credits" />{" "}
                </div>
                <div className="flexCredits">
                  <div />
                  <div className="total">{totalCredit} €</div>
                  <div className="flexCreditsData">
                    <div className="creditsText">
                      {countProforma}{" "}
                      <FormattedMessage id="creditsAndRevenues.proforma" />{" "}
                    </div>
                    <div
                      className={
                        credits.data[0].ImportoTotaleNotule === 0
                          ? "totalCredit dark"
                          : "totalCredit"
                      }
                    >
                      {totalProforma} €
                    </div>
                  </div>
                  <div
                    className="flexCreditsData"
                    style={{ marginRight: "10px" }}
                  >
                    <div className="creditsText">
                      {countInvoices}{" "}
                      {countInvoices > 1 ? (
                        <FormattedMessage id="creditsAndRevenues.invoices" />
                      ) : (
                        <FormattedMessage id="creditsAndRevenues.invoice" />
                      )}
                    </div>
                    <div
                      className={
                        credits.data[0].ImportoDaPagareFatture === 0
                          ? "totalCredit dark"
                          : "totalCredit"
                      }
                    >
                      {totalInvoices} €
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              renderEmptyWidget("credits")
            )}
          </WidgetCard>) : null
        }
        {currentPermissions && permissionUser && isPermissionRevenues ?
          (<WidgetCard type="CreditsAndRevenues">
            {revenues && Object.keys(revenues).length > 0 ? (
              <React.Fragment>
                <div className="flexTitle">
                  <div className={"titleWidgetCreditsAndRevenues"}>
                    <FormattedMessage id="creditsAndRevenues.revenues" />{" "}
                  </div>
                  <div
                    className={
                      positive ? "iconStyleUpDown" : "iconStyleUpDown negative"
                    }
                  >
                    <div style={{ marginRight: "5px" }}>
                      <FontAwesomeIcon
                        icon={[
                          "far",
                          positive ? "long-arrow-up" : "long-arrow-down"
                        ]}
                      />
                    </div>

                    {percentage + "%"}
                  </div>
                </div>
                <div className="flexCredits flexRevenues">
                  <div className="total">{totalRevenues} €</div>
                  {/* <div className="flexCredits flexRevenues"> */}
                  <div className="yearRevenues">
                    <FormattedMessage id="creditsAndRevenues.year" />{" "}
                    {yearRevenues}
                  </div>
                  <div className="totalCredit revenues">{totalOldYear} €</div>
                </div>
                {/* </div> */}
              </React.Fragment>
            ) : (
              renderEmptyWidget("revenues")
            )}
          </WidgetCard>) : null
        }
      </div>
    );
  } return null;
};

export default injectIntl(WidgetCreditsAndRevenues);
